var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlannigAnunciosPresupuesto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7fd4dd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.22,24.4A8,8,0,0,0,72.6,27.53a7.88,7.88,0,0,0,.56,1.7L60.1,41.67a9,9,0,0,0-13.25,3.18L27.3,41.58A8,8,0,1,0,27,46.15l18.75,3.14a9.09,9.09,0,0,0,9.08,8.91A8.93,8.93,0,0,0,59,57.15l8.46,11.76A7.88,7.88,0,0,0,65.56,74a8,8,0,1,0,8-8,7.83,7.83,0,0,0-2.23.36L62.44,54.12a8.95,8.95,0,0,0,.59-9L76.15,32.68A8,8,0,0,0,88.22,24.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlannigAnunciosPresupuesto);
export default __webpack_public_path__ + "static/media/IconPlannig-AnunciosPresupuesto.ee1360488057f50eeb672689876180c5.svg";
export { ForwardRef as ReactComponent };